class FloatingLabels {
  constructor(options = {}) {
    this.config = {
      floatLabels: document.querySelectorAll('.js-floatinglabel'),
      floatClassName: 'is-floating',
      floatFields: 'input, textarea, select',
      ...options
    };
  }

  init() {
    const { floatLabels, floatClassName, floatFields } = this.config;

    const handleFocus = e => {
      const { target } = e;
      target.parentNode.querySelector('label').classList.add(floatClassName);
    };

    const handleBlur = e => {
      const { target } = e;
      if (!target.value) {
        target.parentNode.querySelector('label').classList.remove(floatClassName);
      }
    };

    const bindEvents = element => {
      const floatField = element.parentNode.querySelector(floatFields);
      floatField.addEventListener('focus', handleFocus);
      floatField.addEventListener('blur', handleBlur);
    };

    if (floatLabels) {
      floatLabels.forEach(element => {
        const select = element.parentNode.querySelector('select');
        const input = element.parentNode.querySelector('input, textarea');
        const inputValue = input != null ? input.value : '';

        if (select) {
          const selectedValue = select[select.selectedIndex].value;
          if (selectedValue.length) {
            element.classList.add(floatClassName);
          }
        }

        if (inputValue) {
          element.classList.add(floatClassName);
        }

        bindEvents(element);
      });
    }
  }
}
export default FloatingLabels;
